import InnerSection from "../components/contact-dark/inner-section";

export default function ContactDark() {
	return <InnerSection />;
}
